export const todayISO = () => new Date().toISOString().split("T")[0];

export const addDays = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d.toISOString().split("T")[0];
};

export const daysLeft = (dateISO) => {
  if (!dateISO) return null;
  return Math.ceil((new Date(dateISO) - new Date(todayISO())) / 86400000);
};

export const fmtDate = (dateISO) => {
  if (!dateISO) return "-";
  return new Date(dateISO).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const parseSubtasks = (lines = []) =>
  lines.map((line) => {
    const isSpenglerei = /^\[S\]/.test(line);
    return {
      id: Math.random().toString(36).slice(2) + Date.now(),
      text: line.replace(/^\[S\]\s*/, ""),
      done: false,
      dept: isSpenglerei ? "Spenglerei" : null,
    };
  });

export const calcProgress = (subs) => {
  if (!subs || subs.length === 0) return 0;
  const done = subs.filter((s) => s.done).length;
  return Math.round((done / subs.length) * 100);
};
